import * as React from "react";
import { Button, Stack, TextField, Typography } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";

export const AddUberStoreIdDialog = ({ state, onChange, handleUpdate }) => {
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    }),
  );
  const options = React.useMemo(
    () =>
      (state?.uberStores ?? []).map((store) => ({
        label: store?.name ?? "",
        value: store?.store_id,
        address: store?.location?.address ?? "",
        isLinked: !!store?.is_linked,
        linkedStoreName: store?.pos_store_name ?? "",
        selectable: store?.selectable !== false,
      })),
    [state?.uberStores],
  );
  const selectedOption =
    options.find((option) => option.value === state?.data?.ubereats_store_id) ??
    null;

  const onSubmit = () => {
    if (validator.current.allValid()) {
      handleUpdate();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  return (
    <Stack
      justifyContent="space-between"
      height="100%"
      gap="44px"
      maxHeight={"calc(100% - 24px)"}
      mt="32px"
    >
      <InputControl
        type="dropdown"
        options={options}
        value={selectedOption}
        loading={state?.isUberStoresBusy}
        getOptionLabel={(option) => option?.label ?? ""}
        isOptionEqualToValue={(option, val) => option?.value === val?.value}
        getOptionDisabled={(option) => !option?.selectable}
        onChange={(e, newValue) => {
          onChange({
            target: {
              name: "ubereats_store_id",
              value: newValue?.value ?? "",
            },
          });
        }}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            <Stack>
              <Typography variant="body2">{option.label}</Typography>
              {option.address ? (
                <Typography variant="caption" color="#808080">
                  {option.address}
                </Typography>
              ) : null}
              {option.isLinked ? (
                <Typography variant="caption" color="#C07302">
                  Linked to {option.linkedStoreName || "another store"}
                </Typography>
              ) : null}
            </Stack>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Uber Eats Store"
            required
            sx={{ bgcolor: "#fff" }}
            error={validator.current.message(
              "Uber Eats Store",
              state.data.ubereats_store_id,
              "required",
            )}
            helperText={validator.current.message(
              "Uber Eats Store",
              state.data.ubereats_store_id,
              "required",
            )}
          />
        )}
      />
      <Button
        onClick={onSubmit}
        sx={{ height: "40px" }}
        variant="contained"
        fullWidth
        disabled={state?.isSaveButtonBusy}
      >
        Save
      </Button>
    </Stack>
  );
};
